import { runTimeConfig } from "~/lib/utils/runtime-config";
import AllTopics from "./AllTopics";
import { Featured } from "./Featured";
import Hero from "./Hero";
import RecentActivities from "./RecentActivities";
import FindMoreHelp from "./FindMoreHelp";
import TutorialVideos from "./TutorialVideos";
import Container from "../../layout/Container";
import { useIsMobileUser } from "~/lib/utils/store/useIsMobileUser";
import { useAuth } from "~/lib/utils/hooks/useAuth";

const Separator = () => <hr className="md:hidden h-2 bg-gray-500" />;

const Home = () => {
  const { isMobileUser } = useIsMobileUser();
  const { isAuthorized } = useAuth();

  return (
    <>
      <Hero />

      {isAuthorized && (
        <div className="block md:hidden">
          {runTimeConfig.HELP_CENTRE.TRANSACTION_ENABLED && (
            <div className="flex flex-col gap-4 p-5 md:border md:border-gray-500 md:rounded-xl">
              <RecentActivities />
            </div>
          )}
          <Separator />
        </div>
      )}

      <Container className="flex flex-col md:flex-row md:gap-10 md:pt-10 md:px-[50px] xl:px-[100px]">
        <div className="flex flex-col md:gap-14 w-full md:w-2/3">
          <Featured />
          <Separator />
          <AllTopics />
        </div>
        <div className="hidden md:flex flex-col md:gap-5 md:w-1/3">
          {isAuthorized && runTimeConfig.HELP_CENTRE.TRANSACTION_ENABLED && (
            <div className="flex flex-col gap-4 p-5 md:border md:border-gray-500 md:rounded-xl">
              <RecentActivities />
            </div>
          )}
          <FindMoreHelp />
        </div>
      </Container>

      <Separator />
      <Container className="w-full md:pt-14 md:pb-10 my-5 md:my-0 md:px-[50px] xl:px-[100px]">
        <TutorialVideos />
      </Container>

      <Separator />
      {isMobileUser && <FindMoreHelp />}
    </>
  );
};

export default Home;
